import React, {Component} from 'react';
import {InputText} from 'primereact/inputtext';
import {Calendar} from 'primereact/calendar';
import {RadioButton} from 'primereact/radiobutton';
import {Button} from 'primereact/button';
import {FileUpload} from 'primereact/fileupload';
import {Panel} from 'primereact/panel';
import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';
import * as auth from "../../actions/auth";
import * as management from "../../actions/management";
import connect from "react-redux/es/connect/connect";
import {Dialog} from "primereact/dialog";
import {InputTextarea} from "primereact/inputtextarea";
import {Toast} from 'primereact/toast';
//datatable
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import default_profil from "../../resources/images/logo/user2.png";
import {PickList} from "primereact/picklist";
//form validation
import {Dropdown} from 'primereact/dropdown';
import {addLocale} from 'primereact/api';
import {Message} from "primereact/message";
import axios from "axios";


class User extends Component {

    constructor(props) {
        super(props);

        this.state = {
            image_file_max_size: 200,
            pers_id: null,
            user_username: "",
            user_email: "",
            new_pers_contact_content: "",
            user_address: "",
            confirmPassword: "",
            user_business_address: "",
            pers_contact_uptate_list: [],
            user_password: "",
            user_id: null,
            pers_tcid: "",
            pers_name: "",
            pers_surname: "",
            pers_birthday: "",
            pers_detail: "",
            pers_workinginstitute: "",
            pers_photo: default_profil,
            pers_title: "",
            inst_id: null,
            // dept_id: null,
            ugt_id: null,
            upg_schoolname: '',
            upg_starttime: null,
            upg_graduationtime: null,
            ctyp_name: "",
            gend_id: null,
            data: null,
            institutions: [],
            departments: [],
            gender: [],
            edit_contact_data: [],
            contact_types: [],
            contact_edit_content: "",
            contact_edit_row_index: "",
            contact_edit_id: "",
            will_be_deleted_pcon_id: null,
            will_be_deleted_row_index: null,
            graduation_row_index: null,
            deleted_graduation_row_index: null,
            contacts: [],
            role_group_path: "/api/role/role_group/list/",
            password_not_match_message: "Şifreler Aynı Değil!",
            role_group: [],
            rugc_source: [],
            rugc_target: [],
            user_rol_group: [],
            user_graduations: [],
            graduations: [],
            contact_info_edit: false,
            delete_popup: false,
            delete_graduation_popup: false,
            graduation_popup_visibility: false,
            user_list_role: !!localStorage.getItem('user_list'),
            user_add_role: !!localStorage.getItem('user_add'),
            user_update_role: !!localStorage.getItem('user_update'),
            user_delete_role: !!localStorage.getItem('user_delete'),
            bttn_name: "Kaydet",
            submit_btn_disable: false,
            displayBasic: false,
            isManager: false,
            comp_manager_delete_flag: false,
            comp_manager_add_flag: false,
            competition_list: [],
            comp_id: null,
            eventManager: "",

        };
        this.cities = [
            {name: 'Öğrenci', code: 'OG'},
            {name: 'Özel Sektör', code: 'OM'},
            {name: 'Akademisyen', code: 'AD'},
        ];
        this.onUpload = this.onUpload.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.logChange = this.logChange.bind(this);
        this.createUserData = this.createUserData.bind(this);
        this.getAllInstitutions = this.getAllInstitutions.bind(this);
        //kuruma bağlı departmanlar için departmen
        this.getDepartments = this.getDepartments.bind(this);
        this.getAllContactTypes = this.getAllContactTypes.bind(this);
        this.showSuccess = this.showSuccess.bind(this);
        this.clear = this.clear.bind(this);
        this.addContact = this.addContact.bind(this);
        this.editContactInitialize = this.editContactInitialize.bind(this);
        this.saveUpdateContact = this.saveUpdateContact.bind(this);
        this.deleteContact = this.deleteContact.bind(this);
        this.listContainsValue = this.listContainsValue.bind(this);
        this.createContactObject = this.createContactObject.bind(this);
        this.deletePopupClick = this.deletePopupClick.bind(this);
        this.deletePopupHide = this.deletePopupHide.bind(this);
        // this.formValid = this.formValid.bind(this);
        this.rugcPickListChange = this.rugcPickListChange.bind(this);
        this.rolListChange = this.rolListChange.bind(this);
        this.institutionInitialize = this.institutionInitialize.bind(this);
        this.getGenders = this.getGenders.bind(this);
        this.getGraduations = this.getGraduations.bind(this);
        this.addUpdateGraduation = this.addUpdateGraduation.bind(this);
        this.dateFormatConvert = this.dateFormatConvert.bind(this);
        this.starttimeTemplate = this.starttimeTemplate.bind(this);
        this.graduationtimeTemplate = this.graduationtimeTemplate.bind(this);
        this.selectUser = this.selectUser.bind(this);
        this.nowDate = new Date().getFullYear();
        this.onCityChange = this.onCityChange.bind(this);

    }


    componentDidMount() {

        this.getAllInstitutions();
        this.getAllContactTypes();
        this.getGenders();
        this.getGraduations();
        this.getCompetition();
        const user_username = this.props.match.params['id'];

        if (user_username !== null) {
            if (this.state.user_list_role) {
                this.selectUser(user_username);

            }
            if (!this.state.user_update_role) {
                this.setState({submit_btn_disable: true});
            }
        }
        //add new user
        else {
            this.getRequest(this.state.role_group_path, "role_group");
            this.setState({bttn_name: "Ekle"});
            if (!this.state.user_add_role) {
                this.setState({submit_btn_disable: true});
            }
        }
    }

    onCityChange(e) {
        this.setState({pers_title: e.value});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            if (nextProps.management.type === 'SELECT_USER' && this.props.management !== nextProps.management) {
                let person_detail = nextProps.management.management;
                if (person_detail.length > 0) {
                    this.createUserData(person_detail);
                    this.getRequest(this.state.role_group_path, "role_group");
                } else {
                    window.location.hash = "/user/"
                }
            } else if (nextProps.management.type === 'UPDATE_PERSON' && this.props.management !== nextProps.management) {
                this.selectUser(this.state.user_username);
                if (nextProps.management.management.result === 1) {
                    this.showSuccess(nextProps.management.management.message);

                } else {
                    this.showError(nextProps.management.management.message);
                }
            } else if (nextProps.management.type === 'DELETE_CONTACT' && this.props.management !== nextProps.management) {
                if (nextProps.management.management.result === 1) {
                    this.showSuccess(nextProps.management.management.message);

                } else {
                    this.showError(nextProps.management.management.message);
                }
            } else if (nextProps.management.type === 'ADD_NEW_USER' && this.props.management !== nextProps.management) {
                if (nextProps.management.management.result === 1) {
                    this.showSuccess(nextProps.management.management.message);

                } else {
                    this.showError(nextProps.management.management.message);
                }
            }
        }
    }

    getRequest(path, putvalue) {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch(path, {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({[putvalue]: res.data});
                        if (putvalue === "role_group") {
                            this.setState({rugc_target: []});
                            this.setState({rugc_source: []});
                            let rlf_list = this.state.role_group;
                            let rfgc_list = this.state.user_rol_group;
                            for (let i = 0; i < rlf_list.length; i++) {
                                let contains = false;
                                for (let j = 0; j < rfgc_list.length; j++) {
                                    if (rlf_list[i].rolg_id === rfgc_list[j].rolg.rolg_id && !rlf_list[i].rolg_flag_delete) {
                                        contains = true;
                                        this.setState({rugc_target: this.state.rugc_target.concat(rlf_list[i])});
                                        break;
                                    }
                                }
                                if (!contains && !rlf_list[i].rolg_flag_delete) {
                                    this.setState({rugc_source: this.state.rugc_source.concat(rlf_list[i])});

                                }
                            }
                        }

                    } else if (res.status === 401 || res.status === 403) {
                        //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                        throw res.data;
                    }
                })
        }
    }

    // getY3ManagerRole(numbers) {
    //     console.log(numbers, "-----")
    //     let headers = {"Content-Type": "application/json"};
    //     let token = localStorage.getItem("token");
    //     let role_path = `/api/role_group_control/`
    //     if (token) {
    //         headers["Authorization"] = `Token ${token}`;
    //         fetch(role_path, {headers, method: "POST", body: numbers})
    //             .then(res => {
    //                 if (res.status < 500) {
    //                     return res.json().then(data => {
    //                         return {status: res.status, data};
    //                     })
    //                 } else {
    //                     console.log("Server Error!");
    //                     throw res;
    //                 }
    //             })
    //             .then(res => {
    //                 if (res.status === 200) {
    //
    //
    //                 } else if (res.status === 401 || res.status === 403) {
    //                     //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
    //                     throw res.data;
    //                 }
    //             })
    //     }
    //
    // }

    rugcPickListChange(event) {
        let first_target_list = this.state.rugc_target
        let last_target_list = event.target
        const diff = last_target_list.filter(x => !first_target_list.includes(x)).concat(first_target_list.filter(x => !last_target_list.includes(x)));
        if (diff.length !== 0) {
            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");
            var rolgs_ids = []
            for (let i = 0; i < diff.length; i++) {
                rolgs_ids.push(diff[i].rolg_id)
            }
            let role_path = `/api/role_group_control/`
            const body = JSON.stringify(rolgs_ids);
            if (token) {
                headers["Authorization"] = `Token ${token}`;
                fetch(role_path, {headers, method: "POST", body})
                    .then(res => {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            if (res.data === true) {
                                this.setState({
                                    displayBasic: true,
                                    eventManager: event
                                });
                            } else {
                                this.setState({
                                    rugc_source: event.source,
                                    rugc_target: event.target
                                });
                            }

                        } else if (res.status === 401 || res.status === 403) {
                            //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                            throw res.data;
                        }
                    })
            }
        } else {
            this.setState({
                rugc_source: event.source,
                rugc_target: event.target
            });
        }
    }

    rolListChange(event) {
        let modules = event.value
        var rolgs_ids = []
        for (let i = 0; i < modules.length; i++) {
            rolgs_ids.push(modules[i].rolg_id)
        }

        let role_path = `/api/role_group_control/`
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(rolgs_ids);
            fetch(role_path, {headers, method: "POST", body})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        if (res.data === true) {
                            this.setState({
                                isManager: true
                            });
                        }


                    } else if (res.status === 401 || res.status === 403) {
                        //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                        throw res.data;
                    }
                })
        }

    }


    onUpload() {
        this.growl.show({severity: 'info', summary: 'Başarılı', detail: 'Dosya Yüklendi.'});
    }

    showSuccess(message) {
        this.growl.show({severity: 'success', summary: message, detail: ''});
    }

    showError(message) {
        this.growl.show({severity: 'error', summary: message, detail: ''});
    }

    clear() {
        this.growl.clear();
    }

    onHideUpdateDialog() {
        this.setState({
            contact_info_edit: false,
            contact_edit_content: "",
            contact_edit_row_index: "",
            contact_edit_id: "",
        })
    }


    deletePopupClick(pcon_id, rowIndex) {
        this.setState({delete_popup: true});
        this.setState({will_be_deleted_pcon_id: pcon_id});
        this.setState({will_be_deleted_row_index: rowIndex});
    }

    deletePopupHide() {
        this.setState({delete_popup: false});
    }

    listContainsValue(list, value) {
        for (let i = 0; i < list.length; i++) {
            if (list[i].pcon_content === (value)) {
                return true;
            }
        }
        return false;
    }

    // formValid(user_password, confirmPassword) {
    //     if (user_password !== confirmPassword) {
    //         return false;
    //     }
    //     return true;
    // }

    submitCompetitor() {
        const obj = {
            comp_id: this.state.comp_id,
            user_id: this.state.user_id,
            pers_name: this.state.pers_name,
            pers_surname: this.state.pers_surname,
            user_username: this.state.user_username,
            user_email: this.state.user_email,

        };
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");

        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);
            fetch("/api/competition_manager/", {headers, method: "POST", body})
                .then(res => {
                    if (res.status < 500) {

                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({comp_manager_add_flag: true})
                    } else if (res.status === 401) {
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })

        }
    }

    deleteCompetitonManager() {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        const data = {
            comp_id: this.state.comp_id,
            competitor_manager_code: this.state.user_username,
            user_id: this.state.user_id
        }
        const body = JSON.stringify(data);
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/competition_manager_delete/", {headers, method: "DELETE", body})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({comp_manager_delete_flag: true})

                    } else if (res.status === 401 || res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    onSubmit = e => {
        e.preventDefault();
        let user_id = this.state.user_id;
        let rugc_list = [];
        let rugc_target_list = this.state.rugc_target;
        for (let i = 0; i < rugc_target_list.length; i++) {
            rugc_list.push({
                'rolg_id': rugc_target_list[i].rolg_id,
                'rolg_name': rugc_target_list[i].rolg_name
            })
        }
        //user update
        if (user_id != null && Number.isInteger(user_id)) {
            if (this.state.user_update_role && this.state.isManager === true) {
                let person_data = {
                    user_email: this.state.user_email,
                    pers_tcid: parseInt(this.state.pers_tcid),
                    pers_name: this.state.pers_name,
                    pers_surname: this.state.pers_surname,
                    pers_birthday: this.state.pers_birthday,
                    pers_photo: this.state.pers_photo,
                    // dept_id: parseInt(this.state.dept_id),
                    inst_id: parseInt(this.state.inst_id),
                    pers_workinginstitute: this.state.pers_workinginstitute,
                    gend_id: this.state.gend_id,
                    pers_title: this.state.pers_title,
                    pers_detail: this.state.pers_detail,
                    user_username: this.state.user_username,
                    // user_password: this.state.user_password,
                    create_or_update_contacts: this.state.pers_contact_uptate_list,
                    role_group: rugc_list,
                    user_graduations: this.state.user_graduations
                };
                this.deleteCompetitonManager();
                this.props.updatePerson(user_id, person_data);
                this.setState({pers_contact_uptate_list: []});

            } else {
                if (this.state.comp_id !== null) {
                    this.submitCompetitor();
                    let person_data = {
                        user_email: this.state.user_email,
                        pers_tcid: parseInt(this.state.pers_tcid),
                        pers_name: this.state.pers_name,
                        pers_surname: this.state.pers_surname,
                        pers_birthday: this.state.pers_birthday,
                        pers_photo: this.state.pers_photo,
                        // dept_id: parseInt(this.state.dept_id),
                        inst_id: parseInt(this.state.inst_id),
                        pers_workinginstitute: this.state.pers_workinginstitute,
                        gend_id: this.state.gend_id,
                        pers_title: this.state.pers_title,
                        pers_detail: this.state.pers_detail,
                        user_username: this.state.user_username,
                        // user_password: this.state.user_password,
                        create_or_update_contacts: this.state.pers_contact_uptate_list,
                        role_group: rugc_list,
                        user_graduations: this.state.user_graduations
                    };
                    this.props.updatePerson(user_id, person_data);
                    this.setState({pers_contact_uptate_list: []});
                } else {
                    let person_data = {
                        user_email: this.state.user_email,
                        pers_tcid: parseInt(this.state.pers_tcid),
                        pers_name: this.state.pers_name,
                        pers_surname: this.state.pers_surname,
                        pers_birthday: this.state.pers_birthday,
                        pers_photo: this.state.pers_photo,
                        // dept_id: parseInt(this.state.dept_id),
                        inst_id: parseInt(this.state.inst_id),
                        pers_workinginstitute: this.state.pers_workinginstitute,
                        gend_id: this.state.gend_id,
                        pers_title: this.state.pers_title,
                        pers_detail: this.state.pers_detail,
                        user_username: this.state.user_username,
                        // user_password: this.state.user_password,
                        create_or_update_contacts: this.state.pers_contact_uptate_list,
                        role_group: rugc_list,
                        user_graduations: this.state.user_graduations
                    };
                    this.props.updatePerson(user_id, person_data);
                    this.setState({pers_contact_uptate_list: []});
                }

            }

        } else {
            //user add
            if (this.state.user_add_role) {
                let person_data = {
                    pers_tcid: parseInt(this.state.pers_tcid),
                    pers_name: this.state.pers_name,
                    pers_surname: this.state.pers_surname,
                    pers_birthday: this.state.pers_birthday,
                    pers_photo: this.state.pers_photo,
                    pers_detail: this.state.pers_detail,
                    // dept_id: parseInt(this.state.dept_id),
                    inst_id: parseInt(this.state.inst_id),
                    pers_workinginstitute: this.state.pers_workinginstitute,
                    gend_id: parseInt(this.state.gend_id),
                    pers_title: this.state.pers_title,
                    user_username: this.state.user_username,
                    // user_password: this.state.user_password,
                    user_email: this.state.user_email,
                    create_or_update_contacts: this.state.pers_contact_uptate_list,
                    role_group: rugc_list,
                    user_graduations: this.state.user_graduations
                };
                this.props.addNewUser(person_data);
                this.setState({pers_contact_uptate_list: []});
                this.setState({will_be_deleted_contacts: []});
            } else {
                this.showError("Yetkiniz Bulunmuyor!")
            }
        }

    }

    createUserData(person_detail) {
        const user = person_detail[0];
        if (user.person.length > 0) {
            const person = user.person[0];
            const graduation = person.graduation;
            // const user = person_detail.user[0];
            const bd = person.pers_birthday;
            let date = bd.split('-');
            const pers_birthday = new Date(date);
            this.setState({
                user_username: user.user_username,
                user_email: user.user_email,
                user_id: parseInt(user.user_id),
                pers_id: parseInt(user.pers_id),
                pers_tcid: person.pers_tcid,
                pers_name: person.pers_name,
                pers_title: person.pers_title,
                pers_surname: person.pers_surname,
                pers_birthday: pers_birthday,
                pers_detail: person.pers_detail,
                pers_workinginstitute: person.pers_workinginstitute,
                gend_id: parseInt(person.gend.gend_id),
                gend_name: person.gend.gend_name,
                inst_id: person.inst_id ? parseInt(person.inst_id) : null,
                // dept_id: person.dept ? parseInt(person.dept.dept_id) : null,
                contacts: person.contact,
                user_rol_group: user.role_group,
                user_graduations: graduation,
            });
            const photo = person.pers_photo;
            if (photo !== null && photo !== "") {
                this.setState({pers_photo: 'data:image/png;base64,' + person.pers_photo});
            }
            if (person.dept)
                this.getDepartments(parseInt(person.dept.inst.inst_id));
        } else {
            this.setState({
                user_username: user.user_username,
                user_email: user.user_email,
                user_id: parseInt(user.user_id)
            });
        }

    }

    logChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    getAllInstitutions() {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/user_institutions/", {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({institutions: res.data});

                    } else if (res.status === 401) {
                        this.props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    getGenders() {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/gender/", {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({gender: res.data});

                    } else if (res.status === 401 || res.status === 403) {
                        //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                        throw res.data;
                    }
                })
        }
    }

    getAllContactTypes() {

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/contact_types/", {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({contact_types: res.data});
                    } else if (res.status === 401 || res.status === 403) {
                        //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                        throw res.data;
                    }
                })
        }
    }

    institutionInitialize(inst_id) {
        this.setState({
            inst_id: inst_id,
            // dept_id: null
        })
        this.getDepartments(inst_id)
    }

    competitionInitialize(comp_id) {
        this.setState({
            comp_id: comp_id,
        })
    }

    compSelect() {
        if (this.state.comp_id === null) {
            this.showError("Yarışma seçimi yapmadan onaylama işlemi gerçekleştirilemez")
        } else {
            this.setState({
                displayBasic: false,
                rugc_source: this.state.eventManager.source,
                rugc_target: this.state.eventManager.target
            })
        }

    }


    getDepartments(inst_id) {

        if (inst_id !== "" && Number.isInteger(parseInt(inst_id))) {
            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");
            if (token) {
                headers["Authorization"] = `Token ${token}`;
                fetch(`/api/user_departments/${inst_id}/`, {headers,})
                    .then(res => {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {

                            this.setState({departments: res.data});
                        } else if (res.status === 401 || res.status === 403) {
                            throw res.data;
                        }
                    })
            }
        }
    }

    handleChange(e) {
        let files = e.files;
        var allFiles = [];
        for (var i = 0; i < files.length; i++) {
            let file = files[i];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            let file_size = Math.round(file.size / 1000);
            reader.onload = () => {
                let fileInfo = {
                    name: file.name,
                    type: file.type,
                    size: file_size + ' kB',
                    base64: reader.result,
                    file: file,
                };
                if (file_size < this.state.image_file_max_size) {
                    this.setState({pers_photo: reader.result})
                } else {
                    alert("Resim Boyutu Çok Büyük Lütfen " + this.state.image_file_max_size + " KB'den Küçük Boyutlu Resim Seçiniz")
                }
            }
        }
    }

    contacttypeButtons(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-6">
                    <Button
                        type="button"
                        // onClick = {this.deletePopupClick}
                        onClick={() => this.deletePopupClick(rowData['pcon_id'], column.rowIndex)}
                        //onClick = {() => this.deleteContact(rowData['pcon_id'],column.rowIndex)}
                        title="Sil"
                        icon="pi pi-trash"
                        className="p-button-danger">
                    </Button>
                </div>
                <div className="p-col-12 p-md-6">
                    <Button
                        type="button"
                        title="Düzenle"
                        icon="pi pi-pencil"
                        className="p-button-warning"
                        onClick={() => this.editContactInitialize(rowData['pcon_id'], rowData['pcon_content'], column.rowIndex)}>
                    </Button>
                </div>
            </div>
        );
    }

    editContactInitialize(pcon_id, content, row_index) {
        this.setState({
            contact_edit_id: pcon_id,
            contact_edit_content: content,
            contact_edit_row_index: row_index,
            contact_info_edit: true,
        });
    }

    addContact() {
        if (this.state.contacttype !== undefined && this.state.new_pers_contact_content !== "") {

            let new_pers_contact_content = this.state.new_pers_contact_content;
            let contact_arr = this.state.contacttype.split("--");
            let new_pers_contact_id = contact_arr[0];
            let new_pers_contact_name = contact_arr[1];
            let contacts_list = [];

            if (new_pers_contact_name === "E-Mail ") {
                let re = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i;

                if (re.test(this.state.new_pers_contact_content)) {
                    if (new_pers_contact_content !== "" && !(this.listContainsValue(this.state.contacts, new_pers_contact_content))) {
                        contacts_list.push(this.createContactObject(new_pers_contact_id, null, new_pers_contact_name,
                            this.state.pers_id, new_pers_contact_content, false));
                    }

                    if (contacts_list.length > 0) {
                        this.setState({pers_contact_uptate_list: this.state.pers_contact_uptate_list.concat(contacts_list)});
                        this.setState({contacts: this.state.contacts.concat(contacts_list)});
                        this.setState({display: false});
                        this.onHideContactDialog();
                    }
                } else {
                    this.showError("Invalid email address. E.g. example@email.com")
                }
            } else {
                if (new_pers_contact_content !== "" && !(this.listContainsValue(this.state.contacts, new_pers_contact_content))) {
                    contacts_list.push(this.createContactObject(new_pers_contact_id, null, new_pers_contact_name,
                        this.state.pers_id, new_pers_contact_content, false));
                }

                if (contacts_list.length > 0) {
                    this.setState({pers_contact_uptate_list: this.state.pers_contact_uptate_list.concat(contacts_list)});
                    this.setState({contacts: this.state.contacts.concat(contacts_list)});
                    this.setState({display: false});
                    this.onHideContactDialog();
                }
            }
        } else {
            this.showError("Please select a contact type and enter information.")
        }

    }

    dateFormatConvert(date) {
        const mont = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();
        return day + '/' + mont + '/' + year;
    }

    dateDbFormat(date) {
        const mont = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();
        return year + '-' + mont + '-' + day;
    }

    deleteContact(pcon_id, rowIndex) {
        //var index = array.indexOf(e.target.value)
        let contacts_list = this.state.contacts;
        let del_con_obj = contacts_list[rowIndex];
        contacts_list.splice(rowIndex, 1);
        this.setState({contacts: contacts_list});
        if ((typeof pcon_id) === "number") {
            del_con_obj.pcon_flag_delete = true;
            this.setState({pers_contact_uptate_list: this.state.pers_contact_uptate_list.concat(del_con_obj)});
        }
        contacts_list = this.state.pers_contact_uptate_list;

        for (let i = 0; i < contacts_list.length; i++) {
            if (contacts_list[i].pcon_id === pcon_id) {
                contacts_list.splice(i, 1);
                this.setState({pers_contact_uptate_list: contacts_list});
            }
        }
        this.deletePopupHide();
    }

    selectUser(user_username) {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        fetch(`/api/user/list/${user_username}/`, {headers, method: "GET"})
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return {status: res.status, data};
                    })
                } else {
                    console.log("Server Error!");
                    throw res;
                }
            })
            .then(res => {
                if (res.status === 200) {
                    let data = res.data.results
                    this.createUserData(data);
                    this.getRequest(this.state.role_group_path, "role_group");
                } else if (res.status === 401 || res.status === 403) {

                    throw res.data;
                }
            })
    }

    saveUpdateContact() {
        let contacts_list = this.state.contacts;
        let selected_item = contacts_list[this.state.contact_edit_row_index];
        let update = this.createContactObject(selected_item.ctyp_id, this.state.contact_edit_id, selected_item.ctyp.ctyp_name,
            this.state.pers_id, this.state.contact_edit_content, false);
        contacts_list[this.state.contact_edit_row_index] = update;
        this.setState({contacts: contacts_list});
        this.setState({pers_contact_uptate_list: this.state.pers_contact_uptate_list.concat(update)});
        this.setState({contact_info_edit: false});
    }

    createContactObject(ctyp_id, pcon_id, ctyp_name, pers_id, pcon_content, status) {
        return (
            {
                pcon_id: pcon_id,
                pers_id: pers_id,
                pcon_content: pcon_content,
                pcon_flag_delete: status,
                ctyp: {
                    ctyp_id: ctyp_id,
                    ctyp_name: ctyp_name,
                }
            }
        )
    }

    rugcTemplate(rg) {
        return (
            <div className="p-clearfix">
                <div style={{fontSize: '12px', float: 'left', margin: '5px 3px 0 0'}}>{rg.rolg_name}</div>
            </div>
        );
    }

    starttimeTemplate(rowData) {
        return this.dateFormatConvert(new Date(rowData.upg_starttime));
    }

    getGraduations() {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/user/graduations/", {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({graduations: res.data});

                    } else if (res.status === 401 || res.status === 403) {
                        //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                        throw res.data;
                    }
                })
        }
    }

    graduationButtons(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-6">
                    <Button
                        type="button"
                        onClick={() => this.deleteGraduationPopupClick(column.rowIndex)}
                        title="Sil"
                        icon="pi pi-trash"
                        className="p-button-danger">
                    </Button>

                </div>
                <div className="p-col-12 p-md-6">
                    <Button
                        type="button"
                        title="Düzenle"
                        icon="pi pi-pencil"
                        className="p-button-warning"
                        onClick={() => this.editGraduationInitialize(rowData, column.rowIndex)}>
                    </Button>
                </div>
            </div>
        );
    }

    contact_type_update_input() {
        let contacts_list = this.state.contacts;
        let selected_item = contacts_list[this.state.contact_edit_row_index];

        if (this.state.contacts.length !== 0 && selected_item !== undefined) {
            let ctyp_name = selected_item.ctyp.ctyp_name
            if (ctyp_name === "Cep Telefonu") {
                return <div>
                    <InputText
                        value={this.state.contact_edit_content}
                        id="numbers"
                        keyfilter="num"
                        onChange={(e) => this.setState({contact_edit_content: e.target.value})}/>
                </div>
            } else if (ctyp_name === "İş Telefonu") {
                return <div>
                    <InputText
                        value={this.state.contact_edit_content}
                        id="numbers"
                        keyfilter="num"
                        onChange={(e) => this.setState({contact_edit_content: e.target.value})}/>
                </div>
            } else if (ctyp_name === "E-Posta") {
                return <div>
                    <InputText
                        value={this.state.contact_edit_content}
                        onChange={(e) => this.setState({contact_edit_content: e.target.value})}/>
                </div>
            } else if (ctyp_name === "Ev Adresi") {
                return <div>
                    <InputTextarea
                        id="contact_edit_content"
                        name="contact_edit_content"
                        value={this.state.contact_edit_content}
                        onChange={(e) => this.setState({contact_edit_content: e.target.value})}
                        rows={7}
                        cols={30}
                        autoResize={true}/>
                </div>
            } else if (ctyp_name === "İş Adresi") {
                return <div>
                    <InputTextarea
                        id="contact_edit_content"
                        name="contact_edit_content"
                        value={this.state.contact_edit_content}
                        onChange={(e) => this.setState({contact_edit_content: e.target.value})}
                        rows={7}
                        cols={30}
                        autoResize={true}/>
                </div>
            } else {
                return null
            }
        } else {
            return <div></div>
        }
    }

    editGraduationInitialize(rowData, row_index) {
        this.setState({
            ugt_id: rowData.ugt.ugt_id,
            upg_schoolname: rowData.upg_schoolname,
            upg_graduationtime: new Date(rowData.upg_graduationtime),
            upg_starttime: new Date(rowData.upg_starttime),
            graduation_popup_visibility: true,
            graduation_row_index: row_index,
        });
    }

    graduationNameById(ugt_id) {
        const graduations = this.state.graduations;
        for (let i = 0; i < graduations.length; i++) {
            const graduation = graduations[i];
            if (graduation.ugt_id === ugt_id) {
                return graduation.ugd_name;
            }
        }
        return null;
    }

    contact_type_input() {
        if (this.state.contacttype) {
            const cont_type_name = this.state.contacttype.split("--")[1];
            if (cont_type_name === "Cep Telefonu") {
                return <div>
                    <InputText
                        value={this.state.new_pers_contact_content}
                        id="numbers"
                        keyfilter="num"
                        minLength={11}
                        maxLength={11}
                        onChange={(e) => this.setState({new_pers_contact_content: e.target.value})}/>
                </div>
            } else if (cont_type_name === "İş Telefonu") {
                return <div>
                    <InputText
                        value={this.state.new_pers_contact_content}
                        id="numbers"
                        keyfilter="num"
                        onChange={(e) => this.setState({new_pers_contact_content: e.target.value})}/>
                </div>
            } else if (cont_type_name === "E-Posta") {
                return <div>
                    <InputText
                        value={this.state.new_pers_contact_content}
                        onChange={(e) => this.setState({new_pers_contact_content: e.target.value})}/>
                </div>
            } else if (cont_type_name === "Ev Adresi") {
                return <div>
                    <InputTextarea
                        id="new_pers_contact_content"
                        name="new_pers_contact_content"
                        onChange={this.logChange}
                        rows={7}
                        cols={30}
                        autoResize={true}/>
                </div>
            } else if (cont_type_name === "İş Adresi") {
                return <div>
                    <InputTextarea
                        id="new_pers_contact_content"
                        name="new_pers_contact_content"
                        onChange={this.logChange}
                        rows={7}
                        cols={30}
                        autoResize={true}/>
                </div>
            } else {
                return null
            }
        }

    }

    addUpdateGraduation() {
        const state = this.state;
        if (state.upg_starttime !== null && state.upg_graduationtime !== null && state.upg_schoolname !== null) {

            if (state.graduation_row_index === null) {
                const data = {
                    "upg_id": null,
                    "upg_schoolname": state.upg_schoolname,
                    "upg_starttime": this.dateDbFormat(state.upg_starttime),
                    "upg_graduationtime": this.dateDbFormat(state.upg_graduationtime),
                    "upg_flag_delete": false,
                    "ugt": {
                        "ugt_id": state.ugt_id,
                        "ugd_name": this.graduationNameById(state.ugt_id)
                    }
                }
                this.setState({
                    user_graduations: this.state.user_graduations.concat(data),
                });
            } else {
                const graduations = this.state.user_graduations.slice()
                const data = {
                    "upg_id": graduations[state.graduation_row_index].upg_id,
                    "upg_schoolname": state.upg_schoolname,
                    "upg_starttime": this.dateDbFormat(state.upg_starttime),
                    "upg_graduationtime": this.dateDbFormat(state.upg_graduationtime),
                    "upg_flag_delete": false,
                    "ugt": {
                        "ugt_id": state.ugt_id,
                        "ugd_name": this.graduationNameById(state.ugt_id)
                    }
                }

                graduations[state.graduation_row_index] = data;
                this.setState({user_graduations: graduations});
            }
            this.setState({
                    graduation_popup_visibility: false,
                    graduation_row_index: null,
                }
            );
        } else {
            this.showError("Lütfen bütün form elemanlarını doldurunuz!");

        }
    }

    graduationtimeTemplate(rowData) {
        return this.dateFormatConvert(new Date(rowData.upg_graduationtime));
    }

    deleteGraduationPopupClick(rowIndex) {
        this.setState({delete_graduation_popup: true});
        this.setState({deleted_graduation_row_index: rowIndex});

    }

    deleteGraduation() {
        this.state.user_graduations.splice(this.state.deleted_graduation_row_index, 1)
        this.setState({delete_graduation_popup: false})
    }

    onHideContactDialog() {
        this.setState({
            display: false,
            contacttype: undefined,
            new_pers_contact_content: "",
        })
    }

    renderFooter() {
        return (
            <div>
                <Button label="Vazgeç" icon="pi pi-times" onClick={() => this.setState({displayBasic: false})}
                        className="p-button-text"/>
                <Button label="Onayla" icon="pi pi-check" onClick={() => this.compSelect()} autoFocus/>
            </div>
        );
    }

    getCompetition() {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/competition/', {"headers": headers})
            .then(res => {
                this.setState({competition_list: res.data.competition_list})
            })
    }

    render() {
        const minDate = this.state.upg_starttime
        let user_id = this.state.user_id;
        if ((this.state.user_list_role && user_id != null && Number.isInteger(user_id))
            || (this.state.user_add_role && !Number.isInteger(user_id))) {

            let instOptionItems = [];
            let deptOptionItems = [];
            let genderOptionItems = [];
            let contactTypesItems = [];
            let graduationItems = [];
            let competitonItems = [];

            const competiton = this.state.competition_list;
            competitonItems = competiton.map((item) => (
                    {"label": item.comp_name, "value": item.comp_id}
                )
            );

            const gend = this.state.gender;
            genderOptionItems = gend.map((gender) =>
                <div className="p-col-12" key={gender.gend_name}>
                    <RadioButton
                        disabled={true}
                        value={gender.gend_id}
                        inputId={gender.gend_name}
                        onChange={event => this.setState({gend_id: gender.gend_id})}
                        checked={this.state.gend_id === gender.gend_id}/>
                    <label
                        htmlFor={gender.gend_name}
                        className="p-radiobutton-label">
                        {gender.gend_name}
                    </label>
                </div>
            );

            const institutions = this.state.institutions;
            instOptionItems = institutions.map((inst) => (
                    {"label": inst.inst_name, "value": inst.inst_id}
                )
            );

            // const departments = this.state.departments;
            // deptOptionItems = departments.map((dept) => (
            //         {"label": dept.dept_name, "value": dept.dept_id}
            //     )
            // );
            const contact_types = this.state.contact_types;
            contactTypesItems = contact_types.map((contact) => (
                    {"label": contact.ctyp_name, "value": contact.ctyp_id + '--' + contact.ctyp_name}
                )
            );

            const graduation = this.state.graduations;
            graduationItems = graduation.map((ugd) => (
                    {"label": ugd.ugd_name, "value": ugd.ugt_id}
                )
            );

            const delete_popup_footer = (
                <div>
                    <Button label="Evet"
                            icon="pi pi-check"
                            onClick={() => this.deleteContact(this.state.will_be_deleted_pcon_id,
                                this.state.will_be_deleted_row_index)}/>
                    <Button
                        label="Hayır"
                        icon="pi pi-times"
                        onClick={this.deletePopupHide}
                        className="p-button-secondary"/>
                </div>
            );
            const delete_graduation_popup_footer = (
                <div>
                    <Button label="Evet"
                            icon="pi pi-check"
                            onClick={() => this.deleteGraduation()}/>
                    <Button
                        label="Hayır"
                        icon="pi pi-times"
                        onClick={() => this.setState({delete_graduation_popup: false})}
                        className="p-button-secondary"/>
                </div>
            );

            return (
                <div className="p-fluid">
                    <Dialog header="Yarışma Seçimi" visible={this.state.displayBasic} style={{width: '50vw'}}
                            footer={this.renderFooter()} onHide={() => this.setState({displayBasic: false})}>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <p>Seçilen rol gruplarının arasında <span style={{color: '#ff0000'}}>Y3 Yarışma Yürütücüsü yetkisi </span> bulunmaktadır.
                                    Kullanıcıya
                                    vermek istediğiniz Yürütücü yetkisinin hangi yarışmaya ait olacağını lütfen
                                    aşağıdan
                                    seçiniz.
                                    İşlem sonunda bu kullanıcı seçilen yarışmanın yürütücü yetkisine sahip
                                    olacaktır!
                                </p>
                                <div className="p-col-12">
                                    <Dropdown
                                        style={{width: '100%'}}
                                        options={competitonItems}
                                        onChange={e => this.competitionInitialize(e.target.value)}
                                        value={this.state.comp_id}
                                        filter={true}
                                        showClear={true}
                                        required={true}
                                        placeholder="Yarışma Seçiniz"/>
                                </div>
                            </div>
                        </div>

                    </Dialog>


                    <Toast ref={(el) => this.growl = el}/>
                    <div className="p-grid">
                        <form onSubmit={this.onSubmit.bind(this)}>
                            <div className="p-col-12">
                                <div className="card card-w-title">
                                    <center>
                                        <h1>Sistem Kullanıcı Formu</h1>
                                        <div className="profile">
                                            <div>
                                                <img src={this.state.pers_photo} alt=""
                                                     style={{borderRadius: '50%', maxWidth: 130, maxHeight: 130}}/>
                                            </div>
                                        </div>
                                        <div className="p-col-5 p-md-3">
                                            <FileUpload
                                                uploadLabel="seç"
                                                chooseLabel="Fotoğraf Seçiniz"
                                                cancelLabel="iptal"
                                                onSelect={this.handleChange.bind(this)}
                                                name="file"
                                                style={{marginRight: '.25em'}}
                                                mode="basic"
                                                accept="image/jpg, image/jpeg, image/png"/>
                                        </div>

                                        <Panel header="Kişi Bilgileri" toggleable={true}>
                                            <div className="p-grid p-md-10">
                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">T.C</label>
                                                    <span style={{color: "red"}}> (*)</span>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    <InputText value={this.state.pers_tcid}
                                                               onChange={this.logChange}
                                                               name="pers_tcid"
                                                               id="pers_tcid"
                                                               minLength={11}
                                                               maxLength={11}
                                                               keyfilter="int"
                                                               disabled={true}

                                                               required/>
                                                </div>
                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">Ad </label>
                                                    <span style={{color: "red"}}> (*)</span>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    <InputText
                                                        value={this.state.pers_name}
                                                        onChange={this.logChange}
                                                        name="pers_name"
                                                        id="pers_name"
                                                        minLength={2}
                                                        maxLength={50}
                                                        keyfilter="alpha"
                                                        disabled={true}

                                                        required/>
                                                </div>
                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">Soyad</label>
                                                    <span style={{color: "red"}}> (*)</span>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    <InputText
                                                        id="pers_surname"
                                                        value={this.state.pers_surname}
                                                        onChange={this.logChange}
                                                        name="pers_surname"
                                                        keyfilter="alpha"
                                                        minLength={2}
                                                        disabled={true}
                                                        maxLength={50}
                                                        required/>
                                                </div>
                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">E-Posta</label>
                                                    <span style={{color: "red"}}> (*)</span>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    <InputText
                                                        id="user_email"
                                                        value={this.state.user_email}
                                                        onChange={this.logChange}
                                                        name="user_email"
                                                        minLength={2}
                                                        maxLength={50}
                                                        disabled={true}

                                                        required/>
                                                </div>
                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">Doğum Tarihi</label>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    <Calendar
                                                        id="pers_birthday"
                                                        value={this.state.pers_birthday}
                                                        locale="tr"
                                                        name="pers_birthday"
                                                        dateFormat="dd/mm/yy"
                                                        onChange={this.logChange}
                                                        monthNavigator={true}
                                                        yearNavigator={true}
                                                        disabled={true}
                                                        yearRange={"1910:" + this.nowDate}/>
                                                </div>
                                                <div className="p-col-12 p-md-2">
                                                    Cinsiyet
                                                    <span style={{color: "red"}}> (*)</span>
                                                </div>
                                                <div className="p-col-12 p-md-10" align="left">
                                                    <div className="p-grid">

                                                        {genderOptionItems}
                                                    </div>
                                                </div>
                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">Kurum</label>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    <Dropdown options={instOptionItems}
                                                              inputId="inst_id"
                                                              name="inst_id"
                                                              value={this.state.inst_id}
                                                              onChange={e => this.institutionInitialize(e.target.value)}
                                                              filter={true}
                                                              showClear={true}
                                                              emptyMessage="Kayıt Bulunamadı"
                                                              placeholder="Lütfen Kurumunuzu Seçiniz"/>
                                                </div>
                                                {/*<div className="p-col-12 p-md-2">*/}
                                                {/*    <label htmlFor="input">Departman</label>*/}
                                                {/*</div>*/}
                                                {/*<div className="p-col-12 p-md-10">*/}
                                                {/*    <Dropdown options={deptOptionItems}*/}
                                                {/*              inputId="dept_id"*/}
                                                {/*              name="dept_id"*/}
                                                {/*              value={this.state.dept_id}*/}
                                                {/*              onChange={this.logChange}*/}
                                                {/*              filter={true}*/}
                                                {/*              emptyMessage="Kayıt Bulunamadı"*/}
                                                {/*              showClear={true}*/}
                                                {/*              placeholder="Lütfen Departmanınızı Seçiniz"/>*/}
                                                {/*</div>*/}
                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">Çalışılan Kurum</label>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    <InputText id="pers_workinginstitute"
                                                               value={this.state.pers_workinginstitute}
                                                               onChange={this.logChange}
                                                               keyfilter="alpha"
                                                               name="pers_workinginstitute"/>
                                                    <Message severity="info" text="Kurum ve departmanınız seçenekler arasında
                                                    bulunmuyor ise Çalışılan Kurum alanına kendi kurum bilginizi giriniz!"/>
                                                </div>

                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">Ünvanı</label>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    <Dropdown value={this.state.pers_title} options={this.cities}
                                                              onChange={this.onCityChange} optionLabel="name"
                                                              placeholder="Seçiniz"/>

                                                </div>
                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">Personel Detay</label>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    <InputTextarea id="pers_detail"
                                                                   value={this.state.pers_detail}
                                                                   onChange={this.logChange}
                                                                   name="pers_detail"
                                                                   keyfilter="alpha"
                                                                   rows={3}
                                                                   cols={30}>
                                                    </InputTextarea>
                                                </div>
                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">Kullanıcı Adı</label>
                                                    <span style={{color: "red"}}> (*)</span>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    <InputText
                                                        id="user_username"
                                                        name="user_username"
                                                        value={this.state.user_username}
                                                        keyfilter="alpha"
                                                        disabled={true}
                                                        onChange={this.logChange}/>
                                                </div>
                                            </div>
                                        </Panel>
                                        <br/><br/>

                                        <Panel header="Kullanıcı Rol Bilgileri" toggleable={true}>
                                            <div className="p-grid p-md-10">

                                                {/*<div className="p-col-12 p-md-2">*/}
                                                {/*    <label htmlFor="input">Yeni Şifre </label>*/}
                                                {/*</div>*/}
                                                {/*<div className="p-col-12 p-md-10">*/}
                                                {/*    <Password id="user_password" name="user_password"*/}
                                                {/*              weakLabel="Düşük"*/}
                                                {/*              strongLabel="Güçlü"*/}
                                                {/*              mediumLabel="Orta"*/}
                                                {/*              onChange={this.logChange}/>*/}
                                                {/*</div>*/}
                                                {/*<div className="p-col-12 p-md-2">*/}
                                                {/*    <label htmlFor="input">Şifre Tekrar</label>*/}
                                                {/*</div>*/}
                                                {/*<div className="p-col-12 p-md-10">*/}
                                                {/*    <Password id="confirmPassword" name="confirmPassword"*/}
                                                {/*              weakLabel="Düşük"*/}
                                                {/*              strongLabel="Güçlü"*/}
                                                {/*              mediumLabel="Orta"*/}
                                                {/*              onChange={this.logChange}/>*/}
                                                {/*</div>*/}

                                                <div className="p-col-12 p-md-2">
                                                    <label htmlFor="input">Rol Yetkileri</label>
                                                </div>
                                                <div className="p-col-12 p-md-10">
                                                    {/*{JSON.stringify(this.state.rugc_target)}*/}
                                                    <PickList source={this.state.rugc_source}
                                                              target={this.state.rugc_target}
                                                              itemTemplate={this.rugcTemplate}
                                                              sourceHeader="Rol Grupları" targetHeader="Seçilenler"
                                                              responsive={true}
                                                              sourceStyle={{height: '300px'}}
                                                              targetStyle={{height: '300px'}}
                                                              onChange={this.rugcPickListChange}
                                                              onMoveToSource={this.rolListChange}
                                                              onMoveAllToSource={this.rolListChange}

                                                    >

                                                    </PickList>
                                                </div>

                                            </div>
                                        </Panel>

                                    </center>

                                    <Panel header="Eğitim Bilgileri" toggleable={true}>

                                        <DataTable
                                            value={this.state.user_graduations}
                                            emptyMessage="Kayıt bulunamadı"
                                            reorderableColumns={true}>
                                            <Column
                                                header="İşlevler"
                                                body={this.graduationButtons.bind(this)}
                                                style={{textAlign: 'center', width: '6em'}}/>
                                            <Column
                                                field="upg_schoolname"
                                                header="Okul"
                                                sortable={true}
                                                filter={true}/>
                                            <Column
                                                field="ugt.ugd_name"
                                                header="Derece"
                                                sortable={true}
                                                filter={true}/>
                                            <Column
                                                field="upg_starttime"
                                                body={this.starttimeTemplate}
                                                header="Başlama Tarihi"
                                                sortable={true}
                                            />
                                            <Column
                                                field="upg_graduationtime"
                                                header="Bitirme Tarihi"
                                                body={this.graduationtimeTemplate}
                                                sortable={true}
                                            />
                                        </DataTable>

                                        <div className="p-col-12 p-md-4">
                                            <Dialog header="Yeni Eğitim Bilgileri Ekle"
                                                    visible={this.state.graduation_popup_visibility}
                                                    style={{width: '40vw'}}
                                                    onHide={() => this.setState({graduation_popup_visibility: false})}>


                                                <div className="p-grid">
                                                    <div className="p-grid p-md-10" style={{marginTop: '10px'}}
                                                         align="left">
                                                        <div className="p-col-12 p-md-3" align="left">
                                                            <label htmlFor="input">Öğrenim:</label>
                                                            <span style={{color: "red"}}> (*)</span>
                                                        </div>
                                                        <div className="p-grid p-md-9">
                                                            <Dropdown
                                                                options={graduationItems}
                                                                inputId="ugt_id"
                                                                name="ugt_id"
                                                                style={{width: '100%'}}
                                                                onChange={this.logChange}
                                                                value={this.state.ugt_id}
                                                                showClear={true}
                                                                placeholder="Öğrenim Durumu Seçiniz"/>

                                                        </div>

                                                        <div className="p-col-12 p-md-3" align="left">
                                                            <label htmlFor="input">Okul Adı:</label>
                                                            <span style={{color: "red"}}> (*)</span>
                                                        </div>
                                                        <div className="p-col-12 p-md-9">
                                                            <InputText
                                                                id="upg_schoolname"
                                                                name="upg_schoolname"
                                                                value={this.state.upg_schoolname}
                                                                onChange={this.logChange}/>
                                                        </div>
                                                        <div className="p-col-12 p-md-3" align="left">
                                                            <label htmlFor="input">Başlama Zamanı </label>
                                                            <span style={{color: "red"}}> (*)</span>

                                                        </div>
                                                        <div className="p-col-12 p-md-9">
                                                            <Calendar

                                                                id="upg_starttime"
                                                                value={this.state.upg_starttime}
                                                                locale="tr"
                                                                style={{position: 'fixed', zIndex: 4}}
                                                                name="upg_starttime"
                                                                dateFormat="dd/mm/yy"
                                                                showIcon
                                                                onChange={this.logChange}
                                                                monthNavigator={true}
                                                                yearNavigator={true}
                                                                yearRange={'1910: ' + this.nowDate}/>
                                                        </div>
                                                        <div className="p-col-12 p-md-3" align="left">
                                                            <label htmlFor="input">Bitiş Zamanı</label>
                                                            <span style={{color: "red"}}> (*)</span>

                                                        </div>
                                                        <div className="p-col-12 p-md-9">
                                                            <Calendar
                                                                minDate={minDate}
                                                                id="upg_graduationtime"
                                                                value={this.state.upg_graduationtime}
                                                                locale="tr"
                                                                style={{position: 'fixed', zIndex: 3}}
                                                                name="upg_graduationtime"
                                                                dateFormat="dd/mm/yy"
                                                                onChange={this.logChange}
                                                                monthNavigator={true}
                                                                yearNavigator={true}
                                                                showIcon
                                                                yearRange={'1910: ' + this.nowDate}/>
                                                        </div>

                                                    </div>
                                                    <div className="p-col-12 p-md-4">
                                                        <Button
                                                            icon="pi pi-check"
                                                            type="button"
                                                            onClick={this.addUpdateGraduation}
                                                            label="Ekle"/>
                                                    </div>
                                                    <div className="p-g-12 p-md-4">
                                                        <Button
                                                            type="reset"
                                                            icon="pi pi-times"
                                                            onClick={() => this.setState({graduation_popup_visibility: false})}
                                                            label="Vazgeç"
                                                            className="p-button-secondary"/>
                                                    </div>
                                                </div>
                                            </Dialog>
                                            <Button
                                                type="button"
                                                icon="pi pi-plus-circle"
                                                label="Yeni Eğitim Ekle"
                                                onClick={() => this.setState({
                                                    graduation_row_index: null,
                                                    upg_schoolname: '',
                                                    upg_graduationtime: null,
                                                    upg_starttime: null,
                                                    ugt_id: null,
                                                    graduation_popup_visibility: true,

                                                })}/>
                                        </div>


                                    </Panel>

                                    <Panel header="İletişim Bilgileri" toggleable={true}>
                                        <div className="p-grid datatable-responsive-demo">
                                            <DataTable
                                                value={this.state.contacts}
                                                className="p-datatable-responsive-demo"
                                                reorderableColumns={true}
                                                emptyMessage="Kayıt Bulunamadı"
                                            >
                                                <Column
                                                    header="İşlevler"
                                                    body={this.contacttypeButtons.bind(this)}
                                                    style={{textAlign: 'center', width: '6em'}}/>
                                                <Column
                                                    field="ctyp.ctyp_name"
                                                    header="İletişim Türü"

                                                    sortable={true}
                                                    filter={true}/>
                                                <Column
                                                    field="pcon_content"
                                                    header="İçerik"

                                                    sortable={true}
                                                    filter={true}/>
                                            </DataTable>
                                            <div className="p-col-12 p-md-12">
                                                <Dialog header="Yeni İletişim Bilgileri Ekle"
                                                        visible={this.state.display}
                                                        style={{width: '40vw'}}
                                                        onHide={() => this.onHideContactDialog()} maximizable>

                                                    <div className="p-grid" style={{minHeight: '15em'}}>
                                                        <div className="p-col-12">
                                                            <Dropdown
                                                                options={contactTypesItems}
                                                                inputId="contacttype"
                                                                name="contacttype"
                                                                onChange={this.logChange}
                                                                value={this.state.contacttype}
                                                                showClear={true}
                                                                placeholder="İletişim Türünü Seçiniz"/>

                                                        </div>
                                                        <div className="p-col-12">
                                                            {this.contact_type_input()}
                                                        </div>
                                                        <div className="p-col-12">
                                                            <div className="p-grid">
                                                                <div className="p-col-6">
                                                                    <Button
                                                                        icon="pi pi-check"
                                                                        type="button"
                                                                        onClick={this.addContact}
                                                                        label="Ekle"/>
                                                                </div>
                                                                <div className="p-col-6">
                                                                    <Button
                                                                        type="reset"
                                                                        icon="pi pi-times"
                                                                        onClick={() => this.onHideContactDialog()}
                                                                        label="Vazgeç"
                                                                        className="p-button-secondary"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Dialog>
                                                <div className="p-col-12 p-md-4" align="left">

                                                    <Button
                                                        type="button"
                                                        icon="pi pi-plus-circle"
                                                        label="Yeni İletişim Ekle"
                                                        onClick={() => this.setState({display: true})}/>
                                                </div>
                                            </div>
                                        </div>
                                    </Panel></div>
                            </div>
                            <div className="p-col-12 p-md-2" align="left">
                                <Button
                                    label={this.state.bttn_name}
                                    icon="pi pi-save"
                                    disabled={this.state.submit_btn_disable}
                                />
                            </div>
                        </form>
                    </div>

                    <div className="content-section implementation">
                        <Dialog
                            header="İletişim Bilgileri Düzenle"
                            visible={this.state.contact_info_edit}
                            modal={true} width="450px"
                            onHide={() => this.onHideUpdateDialog()}
                        >
                            <div className="p-grid">
                                <div className="p-col-12 p-md-10">
                                    {/*<InputText*/}
                                    {/*    id="contact_edit_content"*/}
                                    {/*    value={this.state.contact_edit_content}*/}
                                    {/*    onChange={this.logChange}*/}
                                    {/*    name="contact_edit_content"/>*/}
                                    {this.contact_type_update_input()}
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <Button
                                        icon="pi pi-check"
                                        onClick={this.saveUpdateContact} type="button"
                                        label="Güncelle"/>
                                </div>
                                <div className="p-g-12 p-md-4">
                                    <Button
                                        type="reset"
                                        icon="pi pi-times"
                                        onClick={() => this.onHideUpdateDialog()}
                                        label="Vazgeç"
                                        className="p-button-secondary"/>
                                </div>
                            </div>
                        </Dialog>
                    </div>

                    <div className="content-section implementation">
                        <Dialog
                            header="Uyarı!"
                            visible={this.state.delete_popup}
                            style={{width: '45vw'}}
                            footer={delete_popup_footer}
                            onHide={this.deletePopupHide}>
                            Silmek İstediğinizden Emin Misiniz!
                        </Dialog>
                    </div>

                    <div className="content-section implementation">
                        <Dialog
                            header="Uyarı!"
                            visible={this.state.delete_graduation_popup}
                            style={{width: '45vw'}}
                            footer={delete_graduation_popup_footer}
                            onHide={() => this.setState({delete_graduation_popup: false})}>
                            Silmek İstediğinizden Emin Misiniz!
                        </Dialog>
                    </div>

                </div>
            );

        } else {
            return (
                <div className="p-fluid">
                    <div className="p-grid">
                        <Toast ref={(el) => this.growl = el}/>
                        <div className="p-col-12">
                            <h1>Yetkiniz Bulunmuyor!</h1>
                        </div>
                    </div>
                </div>
            )
        }
    }
}


const
    mapStateToProps = state => {
        return {
            user: state.auth.user,
            management: state.management,
        }
    }

const
    mapDispatchToProps = dispatch => {
        return {
            getInstitutions: () => {
                return dispatch(management.fetchInstitution());
            },
            // selectUser: (user_username) => {
            //     return dispatch(management.selectUser(user_username));
            // },
            updatePerson: (user_id, person_data) => {
                return dispatch(management.updatePerson(user_id, person_data));
            }, addNewUser: (person_data) => {
                return dispatch(management.addNewUser(person_data));
            },
            getDeleteContact: (pcon_id) => {
                return dispatch(management.deleteContact(pcon_id));
            },
            updatePersonContact: (pcon_id, edit_contact_data) => {
                return dispatch(management.updatePersonContact(pcon_id, edit_contact_data));
            },
            logout: () => dispatch(auth.logout()),
            loadUser: () => {
                return dispatch(auth.loadUser());
            },
        }
    }


export default connect(mapStateToProps, mapDispatchToProps)

(
    User
)
;



// WEBPACK FOOTER //
// ./src/pages/userpages/User.jsx